import { CdkDrag, CdkDragDrop, CdkDropList } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { MatFabButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { BaseCategory, Category } from '@ncessor/shared';
import { MessageService } from '../services/message.service';
import { NcessorService } from '../services/ncessor.service';

@Component({
  selector: 'app-categories',
  templateUrl: './categories.component.html',
  styleUrls: ['./categories.component.scss'],
  imports: [CdkDrag, CdkDropList, MatFabButton, MatIcon],
})
export class CategoriesComponent implements OnInit {
  categories: Category[] = [];
  selectedCategory?: Category;

  constructor(
    private ncessorService: NcessorService,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.refreshCategories();
  }

  onSelect(category: Category): void {
    this.selectedCategory = category;
  }

  addCategory(inputName: string): void {
    const name = inputName.trim();
    if (!name) {
      return;
    }

    const newCategory: BaseCategory = { name, order: this.findMaxOrder() + 1 };
    this.ncessorService.addCategory(newCategory).subscribe((_) => {
      this.refreshCategories();
    });
  }

  deleteCategory(category: Category): void {
    this.ncessorService.deleteCategory(category._id).subscribe((_) => {
      this.refreshCategories();
    });
  }

  drop(event: CdkDragDrop<string[]>) {
    const movedCat = this.categories[event.previousIndex];
    this.ncessorService.changeCategoryOrder(movedCat._id, event.currentIndex).subscribe((_) => {
      this.refreshCategories();
    });
  }

  private refreshCategories(): void {
    this.ncessorService.getCategories().subscribe((result) => {
      this.messageService.logNormal(`Updated categories: ${result.length} items.`);
      return (this.categories = result.sort((c1, c2) => c1.order - c2.order));
    });
  }

  private findMaxOrder(): number {
    if (!this.categories.length) {
      return 0;
    }
    return this.categories.reduce((c0, c1) => (c0.order < c1.order ? c1 : c0)).order;
  }
}
